import { withCompInfo } from '@wix/editor-elements-integrations'
import { FacebookLikeBoxCssVars, FacebookLikeBoxDefinition } from './FacebookLikeBox'
import { COMP_HEIGHTS, COMP_WIDTHS } from './constants'

const getHeights = (
	showFaces: boolean,
	showStream: boolean,
	layoutHeight: number
): {
	currentHeight: number
	minHeight: number
	maxHeight: number
} => {
	return showStream
		? {
			currentHeight: layoutHeight < COMP_HEIGHTS.STREAM ? COMP_HEIGHTS.STREAM : layoutHeight,
			minHeight: COMP_HEIGHTS.STREAM,
			maxHeight: COMP_HEIGHTS.MAX,
		}
		: showFaces
			? {
				currentHeight: COMP_HEIGHTS.FACES,
				minHeight: COMP_HEIGHTS.FACES,
				maxHeight: COMP_HEIGHTS.FACES,
			}
			: {
				currentHeight: COMP_HEIGHTS.SIMPLE,
				minHeight: COMP_HEIGHTS.SIMPLE,
				maxHeight: COMP_HEIGHTS.SIMPLE,
			}
}

export const css = withCompInfo<FacebookLikeBoxCssVars, FacebookLikeBoxDefinition>()(
	['compData', 'compLayout', 'isOneDocMigrated'],
	({ compData, compLayout, isOneDocMigrated }) => {
		const heights: { minHeight?: number; maxHeight?: number } = isOneDocMigrated
			? {}
			: getHeights(compData.showFaces, compData.showStream, compLayout.height!)

		return isOneDocMigrated
			? {}
			: {
				'--min-width': `${COMP_WIDTHS.MIN_WIDTH}px`,
				'--max-width': `${COMP_WIDTHS.MAX_WIDTH}px`,
				'--min-height': `${heights.minHeight}px`,
				'--max-height': `${heights.maxHeight}px`,
			}
	}
)
